import { SubPackageSlugEnum } from '@yaotai/common-utils';

export const BASE_PATH_PREFIX = `${window.location.origin}/${SubPackageSlugEnum.Center}/`;

export const DEFAULT_INITIAL_PATH = `${window.location.origin}/${SubPackageSlugEnum.Center}/user`;

// 登陆后自定义跳转配置的页面
export const JUMP_PATH_CONFIG: Record<string, string> = {
  '/user/change-phone': `${BASE_PATH_PREFIX}user/info`,
};

export const BASIC_LAYOUT_ID = 'basic_layout';
